import React, { useState } from "react";
import { Calculator } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function CalculatorWidget() {
  const [expr, setExpr] = useState("");
  const [result, setResult] = useState("0");

  const press = (k) => {
    if (k === "C") {
      setExpr("");
      setResult("0");
      return;
    }
    if (k === "⌫") {
      setExpr((s) => s.slice(0, -1));
      return;
    }
    if (k === "=") {
      try {
        // safe eval: only allow digits and operators
        if (!/^[\d+\-*/.() ]+$/.test(expr)) {
          setResult("Err");
          return;
        }
        // eslint-disable-next-line no-new-func
        const v = Function(`"use strict"; return (${expr})`)();
        setResult(String(Number.isFinite(v) ? +v.toFixed(4) : "Err"));
      } catch {
        setResult("Err");
      }
      return;
    }
    setExpr((s) => s + k);
  };

  const keys = [
    ["C", "⌫", "/", "*"],
    ["7", "8", "9", "-"],
    ["4", "5", "6", "+"],
    ["1", "2", "3", "="],
    ["0", ".", "(", ")"],
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-start gap-2 border-gray-200"
          data-testid="open-calculator-btn"
        >
          <Calculator className="h-4 w-4" />
          <span>Calculator</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xs" data-testid="calculator-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">
            Quick Calculator
          </DialogTitle>
        </DialogHeader>
        <div className="border border-gray-200 rounded-md p-3 bg-gray-50">
          <div
            className="text-xs text-gray-500 font-mono min-h-[18px] truncate"
            data-testid="calc-expr"
          >
            {expr || " "}
          </div>
          <div
            className="text-2xl font-display font-bold text-right"
            data-testid="calc-result"
          >
            {result}
          </div>
        </div>
        <div className="grid grid-cols-4 gap-2 mt-2">
          {keys.flat().map((k) => (
            <button
              key={k}
              onClick={() => press(k)}
              data-testid={`calc-key-${k}`}
              className={`h-10 rounded-md border border-gray-200 text-sm font-semibold hover:bg-gray-100 active:bg-gray-200 transition-colors ${
                k === "=" ? "bg-black text-white hover:bg-gray-800" : "bg-white"
              }`}
            >
              {k}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
